import { useReducer, useEffect } from 'react';
import { NavigateFunction } from 'react-router-dom';
import {
  clearAuthority,
  goLogin,
  getApplicationPrefix,
} from '../../utils/loginUtils';
import { IBaseContext, IEnum, ILayoutContext, } from '../context/LayoutContext';
import { SUCCESS_STATUS_CODE } from '../../constants/constant';
import { flatChildrenArray } from '../../utils/dataUtils';
import { userInfo } from 'os';
/** 页面分格 */
export type skinType = 'dark' | 'blue';
/** action */
export type actionType =
  | 'changeGlobal'
  | 'changeMenu'
  | 'changeTenant'
  | 'changeApp'
  | 'addRouteTab'
  | 'addCommonRouteTab'
  | 'deleteRouteTab'
  | 'removeRouteTab'
  | 'closeOtherRouteTab'
  | 'closeLeft'
  | 'closeRight'
  | 'changePassword'
  | 'logout'
  | 'changeEnum'
  | 'authorityList'
  | 'isAuthority'
  | 'changeUserInfo'
  | 'updateUserInfo'
  | 'globalData'
  | 'isRoute';

export interface IGlobalAction {
  type: actionType;
  payload?: any;
  [key: string]: any;
}

export interface buttonsType {
  resourceId: string;
  resourceCode: string;
  resourceParentId: string;
  icon: string;
  name: string;
  path: string;
  type: string;
  nodeId: string;
  parentNodeId: string;
}
/** 默认菜单 */
const initRouteTab = [{ name: '首页', path: `/${getApplicationPrefix()}` }];
/** 默认数据 */
const initBaseData: IBaseContext = {
  global: {
    skinType: 'dark',
    changePassword: false,
    isInit: false,
    isMenu: false,
    isUserInfo: true, // 临时开启
    isApp: false,
    isTenant: false,
  },
  menu: [],
  routes: [],
  routeTabs: [{ path: '/', name: '首页', }],
  authority: [],
  fullPages: [],
};

function globalAction(
  state: IBaseContext,
  action: IGlobalAction,
): IBaseContext {
  const routeLocation = window.location;
  const navigate = state.navigate;
  switch (action.type) {
    case 'changeGlobal':
      return { ...state, global: { ...state.global, ...action.payload } };
    case 'changeMenu':
      const { menu, routes, authority, routeTabs: indexTabs, menuHelp, watermarkConfig, } = action.payload;
      return {
        ...state,
        global: { ...state.global, isMenu: true },
        menu,
        routes,
        authority,
        menuHelp,
        watermarkConfig,
        routeTabs: indexTabs
      };
    case 'changeUserInfo':
      return {
        ...state,
        global: { ...state.global, isUserInfo: true },
        userInfo: action.payload.userInfo,
        menu: action.payload.menu,
        routes: action.payload.routes,
      };
    case 'changeTenant':
      return {
        ...state,
        global: { ...state.global, isTenant: true },
        tenant: action.payload,
      };
    case 'changeApp':
      return {
        ...state,
        global: { ...state.global, isApp: true },
        app: { ...state.app, ...action.payload },
      };
    case 'addRouteTab':
      const oldRouteTabs = state.routeTabs;
      const findRouteTab = oldRouteTabs.find(item => item.path === action.payload?.path);
      if (findRouteTab) return state;
      return { ...state, routeTabs: [...state.routeTabs, action.payload] };
    case 'deleteRouteTab':
      const routeTabs = [...state.routeTabs];
      const findIndex = routeTabs.findIndex(v => v.path === action.payload.key);
      if (findIndex >= 0) {
        if (action.payload.type === 'current') {
          // 判断关闭的页面是否为当前打开的页面
          if (routeLocation?.pathname === action.payload.key) {
            if (findIndex === 0) {
              // 关闭第一个tab后跳转到第二个tab
              const nextRouteTab = routeTabs[findIndex + 1];
              navigate?.(`${nextRouteTab.path}${nextRouteTab.query || ''}`);
            } else {
              // 关闭tab后跳转到前一个tab
              const prevRouteTab = routeTabs[findIndex - 1];
              navigate?.(`${prevRouteTab.path}${prevRouteTab.query || ''}`);
            }
          }
          routeTabs.splice(findIndex, 1);
        }
        if (action.payload.type === 'left' && findIndex > 1) {
          routeTabs.splice(1, findIndex - 1);
          const prevRouteTab = routeTabs[findIndex - 1];
          navigate?.(`${prevRouteTab.path}${prevRouteTab.query || ''}`);
        }
        if (action.payload.type === 'right') {
          routeTabs.splice(findIndex + 1);
          const currentRouteTab = routeTabs[findIndex];
          navigate?.(`${currentRouteTab.path}${currentRouteTab.query || ''}`);
        }
      }
      return { ...state, routeTabs: routeTabs };
    case 'removeRouteTab':
      return { ...state, routeTabs: initRouteTab };
    case 'closeOtherRouteTab':
      if (action.payload.path) {
        navigate?.(`${action.payload.path}${action.payload.query || ''}`);
      } else {
        navigate?.(`/${getApplicationPrefix()}`);
      }
      return {
        ...state,
        routeTabs: state.routeTabs.filter(
          v =>
            v.path === action.payload.path || v.path === initRouteTab[0].path,
        ),
      };
    case 'removeRouteTab':
      return { ...state, routeTabs: initRouteTab };
    case 'changeEnum':
      return {
        ...state,
        global: { ...state.global, isInit: true },
        enumData: action.payload.enumData,
      };
    default:
      return state;
  }
}
export default function(
  /** 菜单 */
  menu: any[],
  /** 修改密码接口 */
  changePasswordApi: (params: {
    oldPassword: string;
    newPassword: string;
    strengthGrade: number;
  }) => Promise<any>,
  /** 获取用户信息接口 */
  getUserInfoApi: () => Promise<any>,
  /** 获取字典 */
  getDictApi: () => Promise<any>,
  /** 退出登录接口 */
  logoutApi: () => Promise<any>,
  /** 路由跳转接口 */
  navigate?: NavigateFunction,
): ILayoutContext {
  const [global, dispatchGlobal] = useReducer(globalAction, {
    ...initBaseData,
    navigate,
  });
  /** 获取用户信息 */
  const getUserInfo = async (isUpdate?: boolean) => {
    dispatchGlobal({
      type: 'changeUserInfo',
      payload: {
        userInfo: {
          name: 'spf101',
        },
        menu: menu,
        routes: flatChildrenArray(menu),
      },
    });
  };
  /** 获取字典 */
  const getDict = async () => {
    const res = await getDictApi();
    if (res.code === SUCCESS_STATUS_CODE) {
      const data = res.data;
      const enumData: IEnum = {};
      if (Array.isArray(data) && data.length) {
        data.forEach(item => {
          enumData[item.dictCode] = {
            name: item.dictName,
            items: item.dicts
              ? item.dicts.map((v: any) => ({
                  value: v.dictDataCode,
                  label: v.dictDataName,
                }))
              : [],
          };
        });
      }
      dispatchGlobal({ type: 'changeEnum', payload: { enumData, }, });
    }
  };
  /** 修改密码 */
  const changePassword = async (options: {
    data: {
      oldPassword: string;
      newPassword: string;
      strengthGrade: number;
    };
    onSuccess: (data: any) => void;
  }) => {
    const resData = await changePasswordApi(options.data);
    if (resData.code === SUCCESS_STATUS_CODE) {
      options.onSuccess?.(resData);
      logout();
      return;
    }
  };
  /** 登出 */
  const logout = async () => {
    // const res = await logoutApi();
    // if (res.code === SUCCESS_STATUS_CODE) {
    //   clearAuthority();
    //   goLogin();
    // }
    window.localStorage.clear();
    goLogin();
  };
  useEffect(() => {
    getUserInfo();
    // getDict();
  }, []);

  // 提供给子组件的全局方法
  const dispatch = (type: actionType, payload?: any) => {
    switch (type) {
      case 'globalData':
        return global;
      case 'updateUserInfo':
        getUserInfo(true);
        break;
      case 'changePassword':
        changePassword(payload);
        break;
      case 'logout':
        logout();
        break;
      case 'authorityList':
        return global.authority;
      case 'isAuthority':
        if (typeof payload === 'string') {
          return global.authority.includes(payload);
        }
        if (Array.isArray(payload)) {
          for (let i = 0; i < payload.length; i++) {
            const authorityStr = payload[i];
            if (global.authority.includes(authorityStr)) return true;
          }
          return false;
        }
        break;
      case 'isRoute':
        return !!global.routes.find(v => v.path === payload);
      default:
        dispatchGlobal({ type, payload });
    }
  };

  return {
    ...global,
    dispatch,
  };
}
